let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ly27m"), load("i3TSs"), load("4Oj5y"), load("dA1E5"), load("6qah4"), load("2Qrvo"), load("eK94l")]).then(() => parcelRequire('8fb5x'));